var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDigitelnew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 548,
    height: 548,
    viewBox: "0 0 548 548",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 548,
    height: 548,
    fill: "#1A77D3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M362.41 280.596C362.323 278.869 362.183 277.304 361.999 275.599L338.091 278.34C338.209 279.42 338.296 280.607 338.36 281.74L362.41 280.596Z",
    fill: "#F48120"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M381.191 411.947C383.005 410.036 385.994 406.701 387.721 404.726L357.207 378.064C355.857 379.608 353.494 382.22 352.09 383.699L381.191 411.947Z",
    fill: "#F48120"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100.199 348.704C98.7422 345.153 97.4793 341.677 96.2703 338.007L72.4263 345.962C73.7539 350.021 75.3946 354.381 76.9922 358.31L98.3428 349.503",
    fill: "#F48120"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M414.35 233.027C413.217 229.605 412.191 226.842 410.885 223.507L391.726 231.063C392.805 233.848 393.82 236.546 394.781 239.406L414.35 233.027Z",
    fill: "#F48120"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M254.004 484.84C263.402 484.829 272.785 484.086 282.068 482.617L278.485 458.945C270.305 460.209 262.043 460.866 253.766 460.91L254.004 484.84Z",
    fill: "#F48120"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M108.576 402.845C106.28 399.967 104.053 397.031 101.894 394.037L81.2991 408.933C83.7277 412.322 86.2104 415.69 88.8549 418.928L108.576 402.845Z",
    fill: "#F48120"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M460.849 272.335C460.554 268.075 460.141 263.854 459.608 259.673L482.923 256.694C483.56 261.616 484.251 266.279 484.586 271.299L460.849 272.335Z",
    fill: "#F48120"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M368.42 326.038C364.542 337.486 358.983 348.294 351.927 358.107L322.448 336.832C327.4 329.907 331.3 322.286 334.02 314.219L368.42 326.038Z",
    fill: "#F48120"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M267.583 102.601L268.76 89.1733C272.214 89.4539 275.639 89.8137 279.036 90.2527H279.392V90.1447L280.299 82.4378C261.499 79.9049 242.443 79.934 223.652 82.5241L226.825 103.616C235.263 102.452 243.771 101.871 252.288 101.878C257.419 101.878 262.496 102.083 267.519 102.493L267.583 102.601Z",
    fill: "#F48120"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M203.358 333.2C207.944 338.013 213.197 342.142 218.956 345.462L209.716 361.718C202.421 357.507 195.75 352.297 189.898 346.239L203.358 333.2Z",
    fill: "#F48120"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M298.691 214.092C300.472 215.236 302.221 216.456 303.916 217.729L331.171 181.559C328.537 179.562 326.13 177.878 323.345 176.086L298.691 214.092Z",
    fill: "#F48120"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M179.385 413.532L168.947 430.576C172.962 432.908 177.079 435.066 181.295 437.052L183.454 432.541C189.152 435.227 195.002 437.581 200.973 439.589L199.386 444.317C207.765 447.094 216.347 449.216 225.055 450.664L228.357 430.943C211.14 428.049 194.565 422.156 179.385 413.532V413.532Z",
    fill: "#F48120"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M126.429 274.969C126.688 272.162 127.048 269.388 127.509 266.646L167.263 272.788C166.928 274.796 166.68 276.469 166.497 278.52L126.429 274.969Z",
    fill: "#00B2EF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M374.896 286.532C374.896 286.651 374.896 286.629 374.896 286.748C374.888 291.195 374.639 295.637 374.151 300.057L338.034 295.934C338.365 292.883 338.528 289.816 338.52 286.748V286.359L374.896 286.532Z",
    fill: "#00B2EF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M328.753 246.838C325.334 240.309 321.089 234.247 316.124 228.801L349.877 198.578C357.411 206.916 363.846 216.184 369.025 226.157L328.753 246.838Z",
    fill: "#00B2EF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M164.499 384.583C154.983 376.04 146.762 366.157 140.093 355.245L114.695 370.735C118.357 376.758 122.421 382.528 126.86 388.005L135.495 381C138.187 384.38 141.047 387.622 144.065 390.714C148.75 395.464 152.031 398.475 152.031 398.475L164.499 384.583Z",
    fill: "#00B2EF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M310.846 161.005C316.496 163.679 321.966 166.719 327.221 170.104L303.031 207.473C299.47 205.164 295.752 203.109 291.903 201.321L310.846 161.005Z",
    fill: "#00B2EF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M387.299 348.978C382.988 358.361 377.691 367.259 371.497 375.521L361.944 368.407C367.664 360.818 372.532 352.623 376.462 343.97L387.299 348.978Z",
    fill: "#00B2EF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M276.595 446.158C268.554 447.384 260.432 448.005 252.297 448.014H251.93C251.93 448.014 251.995 425.789 252.103 425.789C259.144 425.726 266.171 425.156 273.13 424.084L276.595 446.158Z",
    fill: "#00B2EF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M391.251 243.758C392.05 246.478 392.902 249.219 393.55 252.004L413.724 247.104C413.012 243.984 412.073 240.768 411.177 237.713L391.251 243.758Z",
    fill: "#00B2EF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M288.761 120.118C286.419 119.621 282.781 119.038 280.417 118.628L276.963 138.651C279.122 139.007 282.36 139.73 284.519 140.14L288.761 120.118Z",
    fill: "#00B2EF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M441.788 286.76C441.788 290.085 441.702 293.507 441.551 296.799L421.485 295.655C421.625 292.719 421.701 289.642 421.701 286.663L441.788 286.76Z",
    fill: "#00B2EF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M225.636 491.108C218.455 490.222 211.333 488.91 204.307 487.179L207.254 474.571C213.861 476.145 220.544 477.385 227.277 478.284L225.636 491.108Z",
    fill: "#00B2EF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M139.576 86.4102C134.179 89.4433 129.062 92.6059 123.957 96.06L141.713 122.365C146.128 119.386 150.51 116.666 155.173 114.043L139.576 86.4102Z",
    fill: "#00B2EF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M311.128 60.8926C307.63 59.9859 304.155 59.1979 300.604 58.4531L295.606 81.7467C298.725 82.4051 302.082 83.2794 305.094 84.0782L311.128 60.8926Z",
    fill: "#00B2EF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M452.29 220.7C450.855 216.382 449.851 213.036 448.189 208.827L478.963 196.737C480.69 201.055 482.514 205.837 484.003 210.295L452.29 220.7Z",
    fill: "#00B2EF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M336.816 269.691C336.46 267.91 335.985 265.859 335.521 264.121L317.419 268.827C317.851 270.392 318.218 271.99 318.498 273.609L336.816 269.691Z",
    fill: "#00B2EF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M164.933 332.944L154.916 338.492C157.146 342.637 159.626 346.641 162.343 350.484L181.934 336.528C179.003 332.397 176.449 328.012 174.302 323.424L162.904 328.821L164.933 332.944Z",
    fill: "#00B2EF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M186.013 231.635C190.381 226.385 195.36 221.674 200.844 217.603L212.059 232.585C207.788 235.781 203.898 239.457 200.466 243.541L186.013 231.635Z",
    fill: "#00B2EF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M160.732 93.6657C163.301 92.446 168.115 90.4275 170.738 89.251L180.01 111.422C177.722 112.393 173.372 114.39 171.137 115.448L160.732 93.6657Z",
    fill: "#BED747"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M208.301 360.894C205.279 359.038 203.93 358.163 201.825 356.674L175.617 393.525C178.315 395.468 181.5 397.594 185.418 400.001L208.301 360.894Z",
    fill: "#BED747"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M218.6 207.411C220.003 206.817 221.525 206.202 222.918 205.684L218.6 193.811C216.938 194.404 215.362 195.084 213.71 195.764L218.6 207.411Z",
    fill: "#BED747"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M129.118 258.339C129.621 256.116 130.186 253.917 130.812 251.744L169.477 262.689C169.11 263.974 168.656 265.712 168.343 267.007L129.118 258.339Z",
    fill: "#BED747"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M273.207 423.998C280.358 422.817 287.422 421.162 294.353 419.044L301.056 440.459C293.052 442.985 284.863 444.884 276.564 446.137L273.207 423.998Z",
    fill: "#BED747"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M127.713 192.993C126.526 194.558 125.813 195.616 124.68 197.214L140.45 208.17C141.476 206.723 142.112 206.011 143.181 204.564",
    fill: "#BED747"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M195.694 455.178C189.142 452.933 182.711 450.35 176.427 447.439L183.41 432.564C189.108 435.251 194.958 437.605 200.929 439.613L195.694 455.178Z",
    fill: "#BED747"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M102.488 296.214C102.305 293.095 102.175 289.921 102.175 286.759V286.402L80.4575 286.489C80.4575 290.116 80.6194 294.196 80.8353 297.758L102.488 296.214Z",
    fill: "#BED747"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M342.171 175.154C338.135 171.899 333.926 168.865 329.563 166.065L340.249 149.69C345.007 152.743 349.6 156.043 354.012 159.578L342.171 175.154Z",
    fill: "#BED747"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M142.437 415.728C134.431 408.892 127.067 401.337 120.438 393.158L135.442 380.972C141.324 388.25 147.86 394.974 154.969 401.059L142.437 415.728Z",
    fill: "#BED747"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M204.966 96.7601C208.453 95.8966 211.961 95.1302 215.523 94.4502L220.067 117.927C216.937 118.521 213.828 119.201 210.762 119.957L204.966 96.7601Z",
    fill: "#BED747"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M427.345 317.122L455.356 322.012C452.949 335.947 447.984 354.988 440.028 371.837L430.745 367.638L434.567 358.614L417.609 351.944C422.029 340.718 425.285 329.067 427.324 317.176",
    fill: "#BED747"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M264.064 220.256C268.493 221.037 272.833 222.263 277.017 223.915L284.097 206.645C278.727 204.486 273.145 202.898 267.442 201.906L264.064 220.256Z",
    fill: "#EE402F"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M162.848 328.863C162.373 327.838 161.618 326.111 160.689 323.79L126.343 337.909C127.282 340.208 128.318 342.658 129.376 344.882L162.837 328.863",
    fill: "#EE402F"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M127.519 266.67C127.962 263.809 128.501 261.133 129.149 258.337L168.374 267.037C167.9 268.991 167.511 270.826 167.176 272.833L127.519 266.67Z",
    fill: "#EE402F"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M155.023 206.072C161.443 198.354 168.751 191.419 176.795 185.412L200.844 217.568C195.38 221.663 190.404 226.371 186.013 231.6L155.023 206.072Z",
    fill: "#EE402F"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M224.946 163.355C221.783 164.057 218.804 164.802 215.738 165.73L227.342 204.233C228.605 203.855 230.04 203.423 231.336 203.153L231.875 203.024C232.858 202.786 232.955 202.732 233.624 202.592L224.946 163.355Z",
    fill: "#EE402F"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M322.254 415.922C328.257 412.626 334.028 408.922 339.524 404.836L325.2 385.288C320.584 388.678 315.744 391.754 310.715 394.495L322.254 415.922Z",
    fill: "#EE402F"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M381.783 330.672C382.722 327.909 383.661 324.994 384.427 322.155L408.045 328.535C408.045 328.535 406.112 335.302 404.99 338.616L381.783 330.672Z",
    fill: "#EE402F"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M395.374 277.931C395.158 274.132 394.802 271.347 394.295 267.634L414.944 265.043C415.494 269.242 415.775 272.383 416.023 276.679L395.374 277.931Z",
    fill: "#EE402F"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M123.699 223.498C124.778 221.177 125.955 219.05 127.218 216.805L107.152 205.709C105.759 208.202 104.313 210.89 103.05 213.459L123.699 223.498Z",
    fill: "#EE402F"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M255.784 155.321C258.612 155.385 262.995 155.709 265.79 155.936L267.949 134.844C264.603 134.564 259.767 134.197 256.367 134.11L255.784 155.321Z",
    fill: "#EE402F"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M256.455 134.108C254.523 134.108 247.874 133.99 241.603 134.454L243.168 155.632C246.665 155.383 247.421 155.308 250.994 155.308H255.808L256.455 134.108Z",
    fill: "#44C7F4"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M354.475 186.291C350.596 182.347 346.495 178.627 342.191 175.152L354.064 159.576C359.091 163.606 363.874 167.932 368.388 172.529L354.475 186.291Z",
    fill: "#EE402F"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M413.13 406.741C415.569 403.503 417.221 401.409 419.477 398.106L400.209 385.218C398.212 388.208 396.874 390.129 394.704 393L413.13 406.741Z",
    fill: "#EE402F"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M421.592 212.698C419.962 208.985 418.354 205.499 416.454 201.904L443.126 188.261C445.102 192.093 447.444 196.723 449.193 200.685L421.592 212.698Z",
    fill: "#EE402F"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M343.012 129.026C334.336 124.003 325.242 119.738 315.833 116.278L324.317 93.6104C334.988 97.574 345.308 102.427 355.167 108.118L343.012 129.026Z",
    fill: "#EE402F"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2008 181.394C79.0077 175.019 83.1438 168.848 87.5924 162.903L68.6272 148.655C63.634 155.258 59.0176 162.138 54.8 169.261L75.2008 181.394Z",
    fill: "#EE402F"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M197.097 325.617C191.283 317.429 187.4 308.03 185.742 298.125L167.392 301.687C169.612 314.222 174.573 326.113 181.921 336.509L197.097 325.617Z",
    fill: "#EE402F"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M336.849 269.679C337.965 275.171 338.519 280.762 338.501 286.366C338.502 289.56 338.34 292.752 338.015 295.93L319.471 293.771C319.698 291.504 319.806 288.946 319.806 286.615C319.813 282.267 319.397 277.929 318.564 273.662L336.849 269.679Z",
    fill: "#EE402F"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M414.413 172.941C416.075 175.305 417.651 177.637 419.205 180.087L399.02 192.889C397.714 190.859 396.149 188.571 394.757 186.596L414.413 172.941",
    fill: "#EE402F"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M414.414 172.942C414.889 173.612 415.332 174.281 415.807 174.95L422.359 170.417C418.975 165.375 415.328 160.515 411.435 155.855L393.085 170.859C396.032 174.454 398.914 178.048 401.591 181.858L414.414 172.942Z",
    fill: "#BED747"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M304.174 243.529C298.296 236.61 291.124 230.904 283.061 226.733L291.75 210.153C302.101 215.416 311.249 222.766 318.616 231.741L304.174 243.529Z",
    fill: "#0071BB"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M141.94 215.291C138.083 221.216 134.712 227.442 131.859 233.911L190.557 259.288C192.02 256.002 193.753 252.842 195.738 249.843L141.94 215.291Z",
    fill: "#0071BB"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M373.657 223.826C374.974 226.352 376.313 229.115 377.467 231.738L342.678 246.85C341.836 244.939 340.876 242.932 339.915 241.086L373.657 223.826Z",
    fill: "#0071BB"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M406.082 335.216C405.693 336.479 405.315 337.688 405.002 338.616L388.066 332.776C387.257 335.043 386.231 337.796 385.659 339.253L404.894 346.863C405.876 344.38 407.787 338.486 408.64 335.95L406.082 335.216Z",
    fill: "#0071BB"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M127.715 192.992C130.802 188.934 133.112 186.127 136.576 182.36L150.879 195.205C147.845 198.541 145.924 200.98 143.182 204.564L127.715 192.992Z",
    fill: "#0071BB"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1013 256.666C97.4791 254.702 97.6734 253.623 98.1052 251.68L85.6056 248.841C84.1769 254.92 83.0957 261.075 82.3674 267.277L95.2232 268.68C95.6873 264.632 96.3026 260.617 97.0474 256.666",
    fill: "#0071BB"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M279.035 90.3267C283.806 90.9743 288.534 91.7947 293.175 92.7769L288.231 116.168C281.109 114.663 273.899 113.61 266.643 113.016L268.727 89.2041C272.181 89.4847 275.606 89.8445 279.002 90.2835",
    fill: "#0071BB"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M279.035 90.3267C283.806 90.9743 288.534 91.7947 293.175 92.7769L288.231 116.168C281.109 114.663 273.899 113.61 266.643 113.016L268.727 89.2041C272.181 89.4847 275.606 89.8445 279.002 90.2835",
    fill: "#0071BB"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M421.593 212.696C420.676 210.612 419.758 208.594 418.787 206.597L411.231 210.364C412.008 212.145 414.836 218.319 415.549 220.079L437.752 211.206C437.417 210.353 436.597 208.508 435.701 206.511L421.593 212.696Z",
    fill: "#0071BB"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M262.316 353.517C258.907 353.995 255.471 354.254 252.03 354.294L252.105 372.967C256.498 372.947 260.884 372.619 265.231 371.985L262.316 353.517Z",
    fill: "#0071BB"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M224.622 368.407C220.321 367.005 216.15 365.231 212.155 363.107L189.898 406.888C196.076 410.008 202.455 412.713 208.993 414.984L224.622 368.407Z",
    fill: "#0071BB"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M296.446 143.237L300.138 131.019C298.033 130.371 295.68 129.745 293.532 129.184L288.631 148.127C288.631 148.127 292.625 149.207 294.363 149.725C296.101 150.243 298.735 151.16 298.735 151.16L300.947 144.684C299.425 144.198 297.947 143.691 296.446 143.237Z",
    fill: "#0071BB"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M441.788 286.757C441.788 290.082 441.702 293.45 441.54 296.796L454.385 297.584C454.579 293.935 454.676 290.168 454.676 286.509C454.676 282.85 454.352 279.644 454.158 276.05L429.677 277.302C429.861 280.54 429.925 283.422 429.925 286.725L441.788 286.757Z",
    fill: "#FFCC32"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M166.043 286.28C166.043 284.985 166.108 283.614 166.173 282.33C166.504 275.675 167.613 269.082 169.476 262.685L187.491 267.747C185.688 273.734 184.775 279.953 184.782 286.205L166.043 286.28Z",
    fill: "#FFCC32"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M338.498 286.358C338.498 284.782 338.498 283.303 338.358 281.738L374.669 279.957C374.788 282.116 374.864 284.329 374.864 286.498L338.498 286.358Z",
    fill: "#FFCC32"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M164.965 332.98C164.242 331.62 163.519 330.281 162.871 328.889L141.434 339.154C142.341 341.075 143.096 342.554 144.1 344.421L164.965 332.98Z",
    fill: "#FFCC32"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M102.974 301.673L102.466 296.276L119.985 295.078C120.476 303.688 121.803 312.231 123.947 320.584L91.5645 329.22C89.3429 320.738 87.7945 312.094 86.9338 303.368L102.974 301.673Z",
    fill: "#FFCC32"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M226.209 150.443C218.173 151.89 210.298 154.125 202.7 157.114L195.673 138.764C204.383 135.424 213.374 132.87 222.539 131.133L226.209 150.443Z",
    fill: "#FFCC32"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8405 345.28L100.233 348.702L89.7087 353.019C89.7087 353.019 91.792 357.995 92.418 359.377L115.55 348.712C114.729 346.91 112.732 342.149 111.977 340.304L98.8405 345.28Z",
    fill: "#FFCC32"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M354.474 186.298C359.937 191.842 364.937 197.824 369.424 204.183L385.615 193.206C380.438 185.844 374.662 178.923 368.345 172.514L354.474 186.298Z",
    fill: "#FFCC32"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7856 207.306C71.9298 204.705 73.1711 202.06 74.4232 199.513L92.7731 208.45C91.6937 210.728 90.5495 213.146 89.5349 215.477L70.7856 207.306Z",
    fill: "#FFCC32"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M434.578 358.591C432.614 363.578 430.617 368.155 428.275 372.947L404.528 361.074C406.507 357.037 408.306 352.921 409.925 348.726L433.024 357.933L434.578 358.591Z",
    fill: "#FFCC32"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M326.413 465.15C331.551 462.991 334.389 461.696 339.419 459.159L350.138 480.747C350.138 480.747 345.194 483.111 343.014 484.104L335.458 487.45L326.413 465.15Z",
    fill: "#FFCC32"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M125.545 464.486C121.911 461.874 118.36 459.165 114.891 456.358L129.82 437.857C132.971 440.405 135.961 442.769 139.253 445.133L125.545 464.486Z",
    fill: "#FFCC32"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M376.202 122.082C373.72 120.214 371.043 118.228 368.485 116.479L356.331 134.106C357.615 134.991 362.31 138.294 363.358 139.082L376.202 122.082Z",
    fill: "#FFCC32"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M230.527 350.678C226.519 349.262 222.635 347.518 218.913 345.465L209.716 361.656C214.455 364.387 219.448 366.653 224.623 368.424L230.527 350.678Z",
    fill: "#FFCC32"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M239.271 353.015C243.49 353.644 247.737 354.058 251.997 354.256L252.084 372.908C246.627 372.937 241.181 372.42 235.828 371.365L239.271 353.015Z",
    fill: "#FFCC32"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M308.061 324.817C307.025 326.336 305.924 327.807 304.758 329.232L319.276 341.105C320.938 339.087 322.244 337.295 323.712 335.136L308.061 324.817Z",
    fill: "#FFCC32"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M317.42 268.992C317.151 268.02 316.859 267.049 316.546 266.088L334.475 260.54C334.842 261.695 335.155 262.947 335.468 264.124",
    fill: "#FFCC32"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M308.137 221.067C306.799 219.933 305.287 218.735 303.884 217.677L331.172 181.582C333.266 183.158 335.705 185.036 337.648 186.731L308.137 221.067Z",
    fill: "#FFCC32"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M310.726 394.527C298.266 401.326 284.707 405.878 270.669 407.977L267.042 384.456C272.138 383.547 277.182 382.369 282.154 380.927C286.623 379.524 292.451 377.019 292.451 377.019L279.682 348.448C282.507 347.215 285.234 345.772 287.842 344.13L297.687 360.029L303.235 356.273C304.573 355.302 305.642 354.46 306.937 353.402L329.907 381.574C322.772 387.846 310.726 394.527 310.726 394.527Z",
    fill: "#FFCC32"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M297.754 360.012L303.302 356.256L292.195 341.145C290.878 342.116 289.248 343.185 287.877 344.048L288.816 345.602L297.754 360.012Z",
    fill: "#EE402F"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M310.565 454.605C315.066 453.007 318.661 451.55 321.802 450.287L313.674 430.739C310.921 431.883 306.345 433.621 303.517 434.604L310.565 454.605Z",
    fill: "#8AC75A"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M141.238 152.604C130.841 161.206 121.478 170.986 113.335 181.748L94.0571 167.607C103.332 155.307 114.003 144.125 125.856 134.286L141.238 152.604Z",
    fill: "#8AC75A"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M309.344 250.595C307.776 248.114 306.038 245.744 304.141 243.504L318.648 231.738C321.042 234.606 323.245 237.628 325.243 240.784L309.344 250.595Z",
    fill: "#8AC75A"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M323.832 335.15C329.242 327.094 333.236 318.172 335.641 308.77L317.636 303.858C315.664 311.396 312.403 318.535 307.997 324.961L323.832 335.15Z",
    fill: "#8AC75A"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M271.739 202.765C265.422 201.292 258.958 200.542 252.472 200.531C248.4 200.521 244.331 200.792 240.296 201.341L236.594 174.593C241.877 173.9 247.198 173.539 252.526 173.514C261.087 173.547 269.62 174.499 277.978 176.353L271.815 202.593",
    fill: "#8AC75A"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M166.789 297.829C167.363 302.336 168.298 306.79 169.584 311.149L146.561 318.132C143.063 306.229 141.568 293.827 142.135 281.433L166.195 282.512C165.954 287.519 166.131 292.538 166.724 297.516",
    fill: "#8AC75A"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M267.497 201.906C262.483 200.963 257.39 200.507 252.288 200.546C250.551 200.546 248.813 200.546 247.086 200.697L248.165 219.36C249.514 219.274 250.885 219.231 252.245 219.231C256.198 219.243 260.143 219.605 264.032 220.31L267.497 201.906Z",
    fill: "#00AA4E"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M220.554 227.153C225.452 224.579 230.637 222.59 236 221.227L231.488 203.082C224.61 204.742 217.975 207.281 211.746 210.638L220.554 227.153Z",
    fill: "#00AA4E"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M166.086 286.263C166.042 290.131 166.262 293.997 166.744 297.834L185.31 295.265C184.954 292.249 184.777 289.214 184.781 286.177L166.086 286.263Z",
    fill: "#00AA4E"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M334.021 314.217C334.636 312.436 335.165 310.645 335.64 308.82L374.433 319.388C374.433 319.388 372.911 324.785 372.005 327.31L334.021 314.217Z",
    fill: "#00AA4E"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M185.462 379.641C179.84 375.516 174.605 370.888 169.822 365.814L189.91 346.212C193.568 350.072 197.579 353.58 201.891 356.693C201.891 356.693 185.538 379.695 185.462 379.641Z",
    fill: "#00AA4E"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M302.038 124.758C310.587 127.38 318.914 130.679 326.94 134.624L318.358 151.894C311.295 148.439 303.968 145.552 296.447 143.259L302.038 124.758Z",
    fill: "#00AA4E"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8357 297.749L80.663 295.72L71.7363 296.173C71.8767 298.332 72.3192 302.725 72.5351 304.873L102.91 301.71C102.715 299.821 102.586 298.084 102.478 296.173L80.8357 297.749Z",
    fill: "#00AA4E"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M467.391 332.2C468.233 328.152 469.097 324.364 469.701 320.24L493.2 323.964C492.541 328.53 491.667 332.599 490.739 337.111L467.391 332.2Z",
    fill: "#00AA4E"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M190.805 60.5039C186.271 61.7272 181.799 63.0837 177.388 64.5733L184.944 87.0681C188.938 85.7224 192.985 84.4955 197.087 83.3873L190.805 60.5039Z",
    fill: "#00AA4E"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M262.327 353.518C265.844 352.98 269.315 352.176 272.711 351.111L282.155 380.935C277.226 382.539 272.171 383.727 267.044 384.486L262.327 353.518Z",
    fill: "#00AA4E"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M218.654 207.382C216.398 208.332 213.883 209.541 211.735 210.621L198.912 186.787C201.697 185.309 205.14 183.7 208.054 182.47L218.654 207.382Z",
    fill: "#00AA4E"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M277.491 204.269C275.656 203.718 273.638 203.189 271.749 202.736L281.388 161.589C284.351 162.044 287.249 162.849 290.023 163.985L277.491 204.269Z",
    fill: "#00AA4E"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M423.686 113.39L408.51 128.61C404.635 124.778 401.051 121.497 396.917 117.956L410.949 101.689C417.426 107.194 423.686 113.39 423.686 113.39Z",
    fill: "#00AA4E"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M176.297 126.14C172.53 127.921 168.742 129.886 165.212 131.872L151.18 107.045C155.303 104.746 159.631 102.48 163.96 100.429L176.297 126.14Z",
    fill: "#00AA4E"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M176.428 447.438L179.947 439.883C178.198 439.051 175.478 437.778 173.762 436.893L163.875 455.307C169.574 458.243 175.878 461.212 181.89 463.608L186.553 451.734C183.164 450.428 179.98 449.014 176.428 447.438Z",
    fill: "#00AA4E"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M235.838 371.374C241.2 372.447 246.658 372.975 252.126 372.95C254.177 372.95 256.908 372.864 258.916 372.712L262.154 414.216C258.916 414.475 255.429 414.788 252.094 414.788C243.985 414.788 235.896 414.007 227.937 412.456L235.838 371.374Z",
    fill: "#44C7F4"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M170.794 141.771C162.123 146.653 153.924 152.33 146.302 158.728L158.607 173.591C165.424 167.974 172.744 162.998 180.476 158.728L170.794 141.771Z",
    fill: "#44C7F4"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M414.122 304.7C414.457 301.613 414.748 298.396 414.91 295.266L395.481 294.187C395.341 297.004 395.028 299.746 394.736 302.52L414.122 304.7Z",
    fill: "#44C7F4"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M385.919 432.901C376.831 441.269 366.959 448.745 356.44 455.223L343.908 434.855C353.148 429.178 361.823 422.628 369.814 415.296L385.919 432.901Z",
    fill: "#44C7F4"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M416.002 232.563C419.382 242.888 421.774 253.51 423.147 264.287L446.894 261.297C445.313 249.005 442.559 236.893 438.669 225.126L416.002 232.563Z",
    fill: "#44C7F4"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M103.071 213.458C97.3697 225.012 93.058 237.2 90.2266 249.769V249.888L98.1278 251.68C97.696 253.623 97.5017 254.702 97.1239 256.667C97.1239 256.807 97.1239 256.958 97.0484 257.109L111.566 259.818C113.962 247.222 118.043 235.005 123.699 223.496L103.071 213.458Z",
    fill: "#44C7F4"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M369.586 130.826L363.347 139.084C362.268 138.263 361.188 137.475 360.109 136.709L353.633 145.15C356.439 147.309 362.829 152.155 365.506 154.444L379.031 138.727C376.797 136.784 372.824 133.438 369.586 130.826Z",
    fill: "#44C7F4"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M337.205 271.783C336.769 269.194 336.2 266.629 335.5 264.098L379.302 252.635C380.327 256.434 381.191 260.353 381.871 264.271L337.205 271.783Z",
    fill: "#44C7F4"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M227.365 204.186C225.854 204.639 224.375 205.146 222.907 205.675L209.264 167.896C211.315 167.151 213.668 166.363 215.74 165.737L227.365 204.186Z",
    fill: "#44C7F4"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M322.222 372.042C325.741 369.133 329.083 366.015 332.228 362.705L314.828 346.071C312.383 348.674 309.769 351.112 307.002 353.368L322.222 372.042Z",
    fill: "#44C7F4"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M306.98 353.368C309.747 351.111 312.362 348.674 314.806 346.071L315.184 346.449L301.281 333.15C298.511 336.099 295.476 338.787 292.214 341.181L303.321 356.293C304.649 355.332 305.717 354.49 306.98 353.454L307.25 353.789L306.98 353.368Z",
    fill: "#F48120"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6841_9677)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_6841_9677)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.778 254.117V239.071H51.2787V212.457H33.1797V257.594H81.2183L59.3687 334.784H77.9693L100.778 254.117Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_6841_9677)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245.639 334.63V239.055H114.553V257.551H126.047V312.35C126.047 313.841 123.658 316.156 122.216 316.156H111.669V334.653H126.198C134.334 334.653 143.934 325.082 143.934 316.668V257.573H227.752V334.653H245.639V334.63Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_6841_9677)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M290.9 286.727V238.67H257.101V257.759H270.775V286.727H290.9Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_6841_9677)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M344.46 334.631L338.39 303.269V239.055H305.026V257.551H320.502V297.037C320.502 298.016 308.362 316.134 308.061 316.134H295.921V334.631H306.791C312.861 334.631 313.808 334.297 316.52 330.513L324.183 319.784L327.541 334.631H344.46Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_6841_9677)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M383.848 286.727V238.67H354.273V257.759H366.218V286.727H383.848Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_6841_9677)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M514.82 257.27V238.67H396.522V257.27H487.119V334.784H505.273V257.27H514.82Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_6841_9677)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.28 336.078C173.681 336.078 176.458 333.229 176.458 329.69C176.458 326.173 173.703 323.302 170.28 323.302C166.88 323.302 164.103 326.151 164.103 329.69C164.103 333.207 166.858 336.078 170.28 336.078Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_6841_9677)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.127 336.078C195.528 336.078 198.304 333.229 198.304 329.69C198.304 326.173 195.549 323.302 192.127 323.302C188.726 323.302 185.949 326.151 185.949 329.69C185.949 333.207 188.704 336.078 192.127 336.078Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6841_9677",
    x: 20.1797,
    y: 197.457,
    width: 511.641,
    height: 153.621,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6841_9677"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6841_9677",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_6841_9677",
    x: 33.1797,
    y: 212.457,
    width: 75.5986,
    height: 130.327,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6841_9677"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6841_9677",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_6841_9677",
    x: 111.669,
    y: 239.055,
    width: 141.971,
    height: 103.598,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6841_9677"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6841_9677",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_6841_9677",
    x: 257.101,
    y: 238.67,
    width: 41.7993,
    height: 56.0566,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6841_9677"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6841_9677",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_6841_9677",
    x: 295.921,
    y: 239.055,
    width: 56.5383,
    height: 103.576,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6841_9677"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6841_9677",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_6841_9677",
    x: 354.273,
    y: 238.67,
    width: 37.5742,
    height: 56.0566,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6841_9677"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6841_9677",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_6841_9677",
    x: 396.522,
    y: 238.67,
    width: 126.298,
    height: 104.114,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6841_9677"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6841_9677",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_6841_9677",
    x: 164.103,
    y: 323.302,
    width: 20.3552,
    height: 20.7764,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6841_9677"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6841_9677",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_6841_9677",
    x: 185.949,
    y: 323.302,
    width: 20.3552,
    height: 20.7764,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6841_9677"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6841_9677",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitelnew);
export default __webpack_public_path__ + "static/media/digitelnew.cdbf8403789c3b5d0becc8c00c431129.svg";
export { ForwardRef as ReactComponent };